import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import QuoteExport from 'components/quote/Export'
import QuoteSummary from 'components/quote/Summary'

import selectors from 'store/selectors'
import quoteActions from 'store/modules/quote'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
  },
  table: {
    marginTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }
}))

const QuoteTasksExport = ({

}) => {
  const classes = useStyles()

  const quote = useSelector(selectors.quote.collection.item)
  const client = useSelector(selectors.quote.quoteClient)
  const project = useSelector(selectors.project.activeProject)
  const rows = useSelector(selectors.quote.exportedRows)

  return (
    <div className={ classes.root }>
      <div className={ classes.summary }>
        <QuoteSummary
          quote={ quote }
          client={ client }
          project={ project }
        />
      </div>
      <div className={ classes.table }>
        <QuoteExport
          rows={ rows }
        />
      </div>
    </div>
  )
}

export default QuoteTasksExport